jQuery.event.special.touchstart = {
	setup: function( _, ns, handle) {
		this.addEventListener("touchstart", handle, { passive: true });
	}
};
jQuery.event.special.scroll = {
	setup: function( _, ns, handle) {
		this.addEventListener("scroll", handle, { passive: true });
	}
};
jQuery.event.special.wheel = {
	setup: function( _, ns, handle) {
		this.addEventListener("wheel", handle, { passive: true });
	}
};
window.lpcms = {};
lpcms.is_online = true;
lpcms.online_check = function() {
	if (typeof navigator != "undefined" && typeof navigator.onLine == "boolean") {
		lpcms.is_online = navigator.onLine;
		setTimeout(function() {
			lpcms.online_check();
		}, 5000);
	}
};
lpcms.scripts_loaded = new Set();
window.mobileAndTabletcheck = function() {
	var check = false;
	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
	return check;
};
lpcms.unknown_error = function(data) {
	alert('Unbekannter Fehler. Bitte an den Support wenden.');
};
lpcms.is_pwa = function() {
	return ((navigator && navigator.standalone) || matchMedia("(display-mode: standalone)").matches);
};

lpcms.updateNetworkStatus = function() {
	if (navigator.onLine) {
		if (lpcms.is_pwa()) {
			lpcms.indexedDBWrite('last_online', (new Date()).getTime());
		}
		if (lpcms.is_pwa() && !lpcms.is_online) {
			if ($('#videopage-media').length > 0) {
				document.location.href = document.location.pathname;
			} else {
				document.location.href = '/purchases/videos';
			}
		}
		lpcms.is_online = true;
	} else {
		if (lpcms.is_pwa() && !document.location.href.match("offlinemode=true")) {
			lpcms.get_downloaded_vids().then((keys) => {
				if (keys.length > 0) {
					document.location.href = '/purchases/videos?no_ajax=true&offlinemode=true'+$(keys).map(function(i,k) { return "&vids[]="+k; }).toArray().join("");
				} else {
					document.location.href = '/purchases/videos?no_ajax=true&offlinemode=true';
				}
			}).catch((err) => {
				document.location.href = '/purchases/videos?no_ajax=true&offlinemode=true';
			});
		}
		lpcms.is_online = false;
	}
};
lpcms.sliders = [];
lpcms.onsiteload = function(srcelement) {
	extend_jquery();
	if (typeof srcelement == "undefined") {
		srcelement = document;
	}
	if (lazyLoadInstance) {
		lazyLoadInstance.update();
	}
	$('.has-slider', srcelement).each(function() {
		lpcms.sliders[$(this).data('sliderid')] = null;
	});
	$('.has-slider', srcelement).off('mouseenter touchstart').on('mouseenter touchstart', function(e) {
		if (e && e.type && e.type != 'mouseenter') {
			for (idx in lpcms.sliders) {
				var slider = lpcms.sliders[idx];
				if (slider != null && idx != $(this).data('sliderid')) {
					slider.pause();
					if (slider.getCurrentSlideCount() != 1) {
						slider.goToSlide(1);
					}
				}
			}
		}
		if (lpcms.sliders[$(this).data('sliderid')] == null) {
			lazyLoadInstance.load($(this).find('a')[0]);
			$(this).find('.extrathumb.hidden').removeClass('hidden');
			if ($(this).find('a img').length > 1) {
				lpcms.sliders[$(this).data('sliderid')] = $(this).find('a').lightSlider({
					loop: true,
					pause: 1000,
					item: 1,
					pager: false,
					controls: false,
					mode: 'fade',
					useCSS: false
				});
			}
		}
		lpcms.sliders[$(this).data('sliderid')].play();
	}).off('mouseleave').on('mouseleave', function() {
		if (lpcms.sliders[$(this).data('sliderid')] != null) {
			lpcms.sliders[$(this).data('sliderid')].pause();
			if (lpcms.sliders[$(this).data('sliderid')].getCurrentSlideCount() != 1) {
				lpcms.sliders[$(this).data('sliderid')].goToSlide(1);
			}
		}
	});
	$('.toggletrigger', srcelement).off('click').on('click', function(e) {
		$('#'+$(this).data('target')).toggleClass('shown').toggleClass('hidden');
		$(this).toggleClass('active');
		if ((icon = $(this).find('.icon')) && icon.length && !($(this).data('target') == 'cam-filter-menu' && $(this).is(':visible'))) {
			if ($(this).hasClass('active')) {
				icon.removeClass('icon-LPCMS_chevron-down').addClass('icon-LPCMS_chevron-up');
			} else {
				icon.removeClass('icon-LPCMS_chevron-up').addClass('icon-LPCMS_chevron-down');
			}
		}
	});
	$('.startcam', srcelement).off('click').on('click', function() {
		if (!(window.Laravel && window.Laravel.user && window.Laravel.user.authenticated)) {
			lpcms.show_modal('signup');
			return;
		}
		var price = $(this).data('price');
		if ($(this).data('direct')) {
			price = 240;
		}
		if (window.Laravel.user.credits < price) {
			lpcms.payment.dialog('Du hast nicht genug Guthaben um die Cam zu betreten.<br><br>Bitte lade dein Konto auf.');
			return;
		}
		var tobj = this;
		if ($(this).data('direct')) {
			lpcms.external_cam.init('/livecams/'+$(this).data('producer')+'/init');
		} else {
			axios.post('/livecams/'+$(this).data('producer')+'/init').then(function(res) {
				var d = res.data;
				if (d.starturl) {
					lpcms.external_cam.init(d.starturl);
				} else if (d.error) {
					if (d.error == 'sendernotonline') {
						alert('Diese Cam ist leider nicht mehr online!');
					}
					$(tobj).parents('.medialist__item').remove();
				}
			}).catch(function (r) {
				lpcms.unknown_error(r);
			});
		}
	});
	$('video.videosnippet', srcelement).off('mouseover').on('mouseover', function() {
		this.play();
	}).off('touchstart').on('touchstart', function() {
		this.play();
	});
	$('.has-video', srcelement).off('mouseover').on('mouseover', function() {
		var tobj = this;
		window.setTimeout(function() { if (tobj) { $(tobj).find('video')[0].play(); } }, 100);
	}).off('touchstart').on('touchstart', function() {
		var tobj = this;
		window.setTimeout(function() { if (tobj) { $(tobj).find('video')[0].play(); } }, 100);
	});
	$('div.radiobtn-styled', srcelement).off('click touchstart').on('click touchstart', function() {
		$(this).find('input[type=radio]').prop('checked', true);
	});
	setTimeout(function() {
		$('video.videosnippet').not('.nopreload').attr('preload', 'metadata');
	}, 1200);
	$('html, body').off('click touchend').on('click touchend', function(e) {
		if (!($(e.target).hasClass('mobile-menu-icon') || e.target.id == 'mobile-mainmenu' || $(e.target).parent().attr('id') == 'mobile-mainmenu')) {
			window.setTimeout(function() {
				$('#mobile-mainmenu').removeClass('open');
				$('#site-wrapper').css({'filter': 'none'});
				$('html, body').css({'overflow': 'visible', 'position': 'relative', 'height': 'auto'});
			}, 100);
		}
		if (!$(e.target).hasClass('dropdown') && $(e.target).parents('.dropdown').length <= 0) {
			$('.dropdown-menu').removeClass('shown').addClass('hidden');
		}
		$('video.videosnippet').each(function(i, v) {
			if (v != e.target) {
				v.pause();
			}
		});
		if ($(e.target).hasClass('close-icon')) {
			e.preventDefault();
			e.stopPropagation();
			return false;
		}
	});
	$('#mobile-mainmenu').removeClass('open');
	window.setTimeout(function() {
		$('#siteheader-navi-menu-profile').css('display','none').trigger('mouseout');
		window.setTimeout(function() {
			$('#siteheader-navi-menu-profile').css('display','');
		}, 200);
	}, 50);
	$('#site-wrapper').css({'filter': 'none'});
	$('html, body').css({'overflow': 'visible', 'position': 'relative', 'height': 'auto'});
	if (document.getElementById('chat')) {
		Vue.prototype.lpcms = lpcms;
		lpcms.vue_chat = new Vue({
			el: '#chat'
		});
	}
};
jQuery(document).ready(function() {
	lpcms.onsiteload();
});
lpcms.init_ajaxpipe = function(srcelement) {
	if (typeof srcelement == "undefined") {
		srcelement = document;
	}
	lpcms.hijack_modals(srcelement);
	if ($('#landing-wrapper').length > 0) {
		return false;
	}
	$("form.ajaxpipe", srcelement).each(function() {
		$(this)
			.unbind("submit")
			.bind("submit", function(e) {
				e.preventDefault();
				var formData = new FormData($(this)[0]);
				$.ajax({
					type: "POST",
					url: $(this).attr("action"),
					data: formData,
					processData: false,
					contentType: false,
					success: function(data) {
						lpcms.init_ajaxpipe($("div#site-main").html(data));
						lpcms.onsiteload();
					}
				});
			});
	});

	$("a", srcelement)
		.not(".skip-ajaxpipe")
		.each(function() {
			if (
				typeof $(this).attr("href") !== "undefined" &&
				$(this).attr("href") != null &&
				!$(this).attr("href").match(/^#/) &&
				!$(this).attr("href").match(/^javascript/) &&
				(!($(this).attr("href").match(/^http/) && !$(this).attr("href").match(/^https:\/\/www\.leonie-pur\.com/))) &&
				$(this).attr("href") != "/impressum" &&
				$(this).attr("href") != "/logout" &&
				$(this).attr("target") != "_blank" &&
				($(this).attr("rel") && $(this).attr("rel").substr(0,8) != "lightbox")
			) {
				$(this)
					.unbind("click")
					.bind("click", function(e) {
						e.preventDefault();
						lpcms.load_via_ajax(this.href);
					});
			}
		});
};
lpcms.load_via_ajax = function(url, params, dont_pushstate, dont_scrolltop) {
	var method = "POST";
	if (!lpcms.is_online) {
		document.location.href = url+(url.match("\\?") ? "&" : "?")+'no_ajax=true';
		return;
	}
	if (!params) {
		method = "GET";
		params = null;
	}
	return $.ajax({
		url: url,
		type: method,
		dataType: "html",
		data: params,
		error: function(jqXHR, state, err) {
			if (jqXHR.status === 402) {
				//payment
			} else if (jqXHR.status === 404) {
			} else {
				//log error maybe
			}
			return false;
		},
		success: function(data, state, jqXHR) {
			var title = decodeURIComponent(jqXHR.getResponseHeader("X-LPCMS-Pagetitle"));
			if (title == "null") {
				title = jqXHR.getResponseHeader("X-LPCMS-Pagetitle");
			}
			var location = jqXHR.getResponseHeader("X-LPCMS-Location");

			if (title) {
				document.title = title;
			} else {
				document.title = "LEONIE PUR! - Offizielle Homepage von Amateurgirl Leonie Pur!";
			}

			if (!dont_pushstate) {
				try {
					window.history.pushState("lpcms", document.title, (location ? (location == '/' ? location : '/'+location) : url));
				} catch (e) {}
			}

			if (!dont_scrolltop) {
				$(window).scrollTop(0);
			}
			$("div#site-main")[0].innerHTML = data;
			var loadscripts = [];
			var evalscripts = [];
			$("div#site-main").find('script').each(function(){
				if ($(this).attr('src')) {
					loadscripts.push(axios.get($(this).attr('src')));
				} else {
					evalscripts.push(this.text || this.textContent || this.innerHTML || '');
				}
			});

			axios.all(loadscripts).then((results) => {
				$.each(results, function(i, data) {
					if (!lpcms.scripts_loaded.has(data.config.url)) {
						lpcms.scripts_loaded.add(data.config.url);
						$.globalEval(data.data);
					}
				});
			}).then(function() {
				$.each(evalscripts, function(i, s) {
					$.globalEval(s);
				});
			});

			lpcms.init_ajaxpipe($("div#site-main"));

			lpcms.onsiteload($("div#site-main"));
		}
	});
};
lpcms.alert = function(text) {
	alert(text);
};
lpcms.hijack_modals = function(srcelement) {
	if (typeof srcelement == "undefined") {
		srcelement = document;
	}
	$(".modal-trigger", srcelement).off('click').on('click', function(e) {
		var dataModal;
		e.preventDefault();
		switch ($(this)[0].nodeName) {
			case "A":
				dataModal = $(this).attr("href");
				break;

			default:
				dataModal = $(this).attr("data-modal");
				if (!dataModal) {
					dataModal = $(this).find('a').first().attr("href");
				}
				break;
		}
		if (dataModal) {
			lpcms.show_modal(dataModal.replace("#",""));
		}
	});

	$(".close-modal, .modal-sandbox", srcelement).off('click touchstart').on('click touchstart', function(e) {
		if (!$(this).parents('.modal').hasClass('noclose')) {
			lpcms.close_modals();
		}
	});
};
lpcms.close_modals = function() {
	$('#site-wrapper, #sitefooter').show();
	$('#modal-livecam-external').find('iframe').attr('src','');
	$(".modal").hide();
};
lpcms.external_cam = {};
lpcms.external_cam.init = function(url) {
	if (window.mobileAndTabletcheck()) {
		document.location.href = url;
	} else {
		$('#modal-livecam-external iframe').attr('src', url);
		lpcms.show_modal('livecam-external');
	}
};
lpcms.show_modal = async function(name) {
	if (name == 'login') {
		$('#modal-signup').hide();
	} else if (name == 'signup') {
		$('#modal-login').hide();
	}
	$('html, body').css({'overflow': 'auto', 'position': 'relative', 'height': 'auto'});
	if (window.outerWidth < 1000) {
		$('#site-wrapper, #sitefooter').hide();
	}
	if ($("#modal-" + name).length <= 0) {
		try {
			var modalcontent = await axios.get('/loadModal/'+name);
			var appended = $(modalcontent.data).appendTo('body');
			lpcms.init_ajaxpipe(appended);
		} catch (err) {
			return false;
		}
	}
	if ($("#modal-" + name).length <= 0) {
		return false;
	}
	if (name == "signup" && window.mobileAndTabletcheck()) {
		$("#modal-" + name).show();
	} else {
		$("#modal-" + name).show().find('input[type=text]').first().focus();
	}
	return true;
}
lpcms.buy_video = function(id, price) {
	$('#modal-buy-video-coins').text(price);
	$('#modal-buy-video button').data('videoid', id);
	lpcms.show_modal('buy-video');
}

lpcms.gallery = {};
lpcms.gallery.buy = function(id, credits) {
	if (!(window.Laravel && window.Laravel.user && window.Laravel.user.authenticated)) {
		lpcms.show_modal('signup');
		return;
	}
	$('#modal-buy-gallery-coins').text(credits);
	lpcms.show_modal('buy-gallery');
	$('#modal-buy-gallery button').off('click').on('click', function(e){
		axios.post('/bilder/'+id+'/buy', { check_if_bought: 1 }).then(function(res) {
			var d = res.data;
			if (d.success) {
				lpcms.load_via_ajax(document.location.href);
			} else if (d.message) {
				lpcms.payment.dialog(d.message);
			} else {
				axios.post('/bilder/'+id+'/buy').then(function(res) {
					var d = res.data;
					if (d.success) {
						lpcms.close_modals();
						lpcms.load_via_ajax(document.location.href);
					} else if (d.message) {
						lpcms.payment.dialog(d.message);
					}
				});
			}
		});
	});
};

window.addEventListener('popstate', function(event) {
	if (window.location.hash == '') {
		lpcms.load_via_ajax(window.location.pathname+(window.location.search ? window.location.search : ''), null, true, true);
	}
}, false);
$(function() {
	lpcms.init_ajaxpipe();
	$('#siteheader-mobile .mobile-menu-icon').click(function() {
		$('#mobile-mainmenu').toggleClass('open');
		if ($('#mobile-mainmenu').hasClass('open')) {
			$('#site-wrapper').css({'filter': 'blur(15px)'});
			$('html, body').css({'overflow': 'hidden', 'position': 'fixed', 'height': '100%'});
		} else {
			$('#site-wrapper').css({'filter': 'none'});
			$('html, body').css({'overflow': 'visible', 'position': 'relative', 'height': 'auto'});
		}
	});
	$('script').each(function() {
		if ($(this).attr('src')) {
			lpcms.scripts_loaded.add($(this).attr('src'));
		}
	});
});
window.addEventListener("message", lpcms_receive_postmsg, false);
function lpcms_receive_postmsg(event) {
    var origin = event.origin || event.originalEvent.origin;
    if (origin.match('pur\.link')) {
		var data = event.data;
		if (!data && event.originalEvent) {
			data = event.originalEvent.data;
		}
		if (data.token && data.token.length && data.email && data.email.length > 3) {
            data.token = encodeURIComponent(data.token);
            axios.post('/register/mailExists', { mail: data.email }).then(function(res) {
				var d = res.data;
                if (d == "yes") {
					axios.post('/login/socialMedia', { token_type: data.token_type, token: data.token, token_secret: data.token_secret }).then(function() {
						document.location.reload();
					});
                } else if (d == "ppp") {
					lpcms.close_modals();
					lpcms.show_modal('login').then(() => {
						$('#loginform-mainpage').hide();
						$('#pppsync-sendtoken').show();
						$('#pppsync-newpass').show().find('button').click(function(e) {
							e.preventDefault();
							if (!$('#loginform-pppsync-transfer').is(':checked')) {
								alert('Bitte setze den Haken, um der Übertragung deines Guthabens und deiner gekauften Inhalte zuzustimmen.');
							} else {
								if ($('#pppsync-newpass-password').val().length < 8) {
									alert('Bitte gib ein Passwort mit mindestens 8 Zeichen ein.');
								} else {
									$('#pppsync-newpass').find('div.loader').removeClass('hidden');
									$('#pppsync-newpass').find('button[type=submit]').hide();
									axios.post('/login/syncdata', { password: $('#pppsync-newpass-password').val(), identity: $('#pppsync-sendtoken-identity').val(), newsletter: ($('#loginform-pppsync-newsletter').is(':checked') ? 'on' : '') }).then(function(res) {
										document.location.reload();
									}).catch(function(err) {
										$('#pppsync-newpass').find('div.loader').addClass('hidden');
										$('#pppsync-newpass').find('button[type=submit]').show();
										var data = err.response.data;
										if (data.errors) {
											$.each(data.errors, function(field, msgs) {
												alert(msgs[0]);
												return false;
											});
										}
									});
								}
							}
						});
					});
                } else {
					$('#modal-signup .lpmodal-right h2').text('Wähle nun noch einen Benutzernamen')
                    $('#signupform-password').val(Math.random().toString(36).slice(-10)).parent().hide();
                    $('#signupform-email').val(data.email).parent().hide();
                    $('#signupform-token').val(data.token);
					$('#signupform-tokentype').val(data.token_type);
					$('#signupform-tokensecret').val(data.token_secret);
					lpcms.close_modals();
					lpcms.show_modal('signup');
                }
            });
        }
    }
};
lpcms.infinitescroll = {};
lpcms.infinitescroll.add = function(url,selector, windowsize, scrollpercent_top, scrollpercent_bottom, per_page, onload_top, onload_bottom) {
	$(window).off('wheel scroll').on('wheel scroll',function(e) {
		var scroll_percent = (($(window).scrollTop()/($(document).height()-$(window).height()))*100);
		if (scroll_percent > scrollpercent_bottom && !lpcms.infinitescroll.is_loading_bottom) {
			lpcms.infinitescroll.is_loading_bottom = true;
			lpcms.infinitescroll.currentpage++;
			axios.get(url+(url.match(/\?/) ? '&' : '?')+'page='+lpcms.infinitescroll.currentpage+'&via_scroll=true').then(function(d) {
				var html = $(d.data);
				html.insertAfter($(selector+':last'));
				// $(selector+'[data-page='+(lpcms.infinitescroll.currentpage-windowsize-1)+']').remove();
				onload_bottom(html);
				if ($(d.data).filter(selector).length >= per_page) {
					setTimeout(function() {
						lpcms.infinitescroll.is_loading_top = false;
						lpcms.infinitescroll.is_loading_bottom = false;
					}, 1000);
				}
			});
		}/* else if (scroll_percent < scrollpercent_top && lpcms.infinitescroll.currentpage > windowsize && !lpcms.infinitescroll.is_loading_top) {
			lpcms.infinitescroll.is_loading_top = true;
			lpcms.infinitescroll.currentpage--;
			$.get(url+'?page='+(lpcms.infinitescroll.currentpage - windowsize)+'&via_scroll=true', function(d) {
				var html = $(d);
				html.insertBefore($(selector+':first'));
				$(selector+'[data-page='+(lpcms.infinitescroll.currentpage+1)+']').remove();
				onload_top(html);
				if ((lpcms.infinitescroll.currentpage - windowsize) > 1) {
					setTimeout(function() {
						lpcms.infinitescroll.is_loading_top = false;
						lpcms.infinitescroll.is_loading_bottom = false;
					}, 1000);
				}
			});
		}*/
	});
};
lpcms.premium = {};
lpcms.premium.players = [];
lpcms.premium.fixVideoLayout = () => {
	for (var p in lpcms.premium.players) {
		var aspectratio = lpcms.premium.players[p].videoHeight()/lpcms.premium.players[p].videoWidth();
		var maxHeight = window.innerHeight;
		if (!lpcms.premium.players[p].isFullscreen()) {
			if ($(window).width()*aspectratio < (window.innerHeight-68)) {
				maxHeight = $(window).width()*aspectratio;
			} else {
				maxHeight = window.innerHeight-68;
			}
		}
		if (maxHeight < 100) {
			maxHeight = 1500;
		}
		$(lpcms.premium.players[p].el_).add(lpcms.premium.players[p].el_.children[0]).css('max-height', maxHeight);
	}
};
lpcms.premium.imagesliders = [];
lpcms.premium.clicked_but_not_subscribed = function() {
	if (window.Laravel && window.Laravel.user && window.Laravel.user.authenticated) {
		document.location.href = '/be-my-lover';
		return;
	}
	lpcms.show_modal('signup');
};

lpcms.premium.parsePostMedia = function(src) {
	$('.lvrs__postcontent', src).find('video,img').off('contextmenu').on('contextmenu', function(e) {
		e.preventDefault();
		return false;
	}).off('dragstart').on('dragstart', function(e) {
		e.preventDefault();
		return false;
	});
	$('.premium-video', src).each(function(i,v) {
		var options = {
			inactivityTimeout: 2000,
			controlBar: {
				children: [
					'progressControl',
					'playToggle',
					'volumePanel',
					'currentTimeDisplay',
					'durationDisplay',
					'fullscreenToggle',
				]
			}
		};
		var vid = $(v).attr('id');
		if (lpcms.premium.players[vid]) {
			lpcms.premium.players[vid].dispose();
			lpcms.premium.players[vid] = videojs(vid, options);
			var aspectratio = lpcms.premium.players[vid].videoHeight()/lpcms.premium.players[vid].videoWidth();
			if ($(window).width()*aspectratio < (window.innerHeight-68)) {
				$(lpcms.premium.players[vid].el_).css('max-height', $(window).width()*aspectratio);
			} else {
				$(lpcms.premium.players[vid].el_).css('max-height', window.innerHeight-68);
			}
		} else {
			lpcms.premium.players[vid] = videojs(vid, options);
			lpcms.premium.players[vid].on('loadedmetadata', () => {
				var video = videojs(this);
				var aspectratio = video.videoHeight()/video.videoWidth();
				if ($(window).width()*aspectratio < (window.innerHeight-68)) {
					$(video.el_).css('max-height', $(window).width()*aspectratio);
				} else {
					$(video.el_).css('max-height', window.innerHeight-68);
				}
			});
			lpcms.premium.players[vid].on('click', (e) => {
				if (
					!$(e.target).hasClass('vjs-big-play-button') && !$(e.target).parent().hasClass('vjs-big-play-button') &&
					!$(e.target).hasClass('vjs-control') && !$(e.target).parent().hasClass('vjs-control')
				) {
					if (lpcms.premium.players[vid].paused()) {
						lpcms.premium.players[vid].play();
					} else {
						lpcms.premium.players[vid].pause();
					}
				}
			});
			lpcms.premium.players[vid].on('play', (e) => {
				var slider = $(e.target).parents('.lpcms-slider');
				if (slider.length > 0) {
					slider.find('.lSPager').css('visibility','hidden');
				}
				var post = $(e.target).parents('.lvrs__postcontent');
				if (post.length > 0) {
					$(post).find('.premium-video-duration').hide();
				}
			});

			// lpcms.premium.players[vid].on('fullscreenchange', function() {
			// 	setTimeout(function() {
			// 		var ctime = lpcms.premium.players[vid].currentTime();
			// 		lpcms.premium.players[vid].currentTime(0);
			// 		lpcms.premium.players[vid].currentTime(ctime);
			// 	}, 200);
			// });
		}
	});
	$('.premium-audio', src).each(function(i,v) {
		var options = {
			controlBar: {
				children: [
					'playToggle',
					'progressControl',
					'remainingTimeDisplay'
				]
			}
		};
		var vid = $(v).attr('id');
		if (lpcms.premium.players[vid]) {
			lpcms.premium.players[vid].dispose();
		}
		lpcms.premium.players[vid] = videojs(vid, options);
		if ($(v).data('duration')) {
			lpcms.premium.players[vid].duration = function() {
				return $(v).data('duration');
			}
			lpcms.premium.players[vid].remainingTime = function() {
				return $(v).data('duration');
			}
			lpcms.premium.players[vid].remainingTimeDisplay = function() {
				return $(v).data('duration');
			}
			lpcms.premium.players[vid].reset();
		}
		if (!lpcms.premium.hasSubscription) {
			$(lpcms.premium.players[vid].el_).find('button').off('click');
			$(lpcms.premium.players[vid].el_).find('button').on('click', function(e) {
				e.preventDefault();
				lpcms.premium.clicked_but_not_subscribed();
				return false;
			});
		}
	});
};
lpcms.premium.addLightboxBottomData = function(lightbox, srcelem) {};
lpcms.premium.addPostClickHandlers = function(src) {
	$('.lvrs__postcomment__showall', src).off('click').on('click', function() {
		lpcms.show_modal('signup');
	});
	$('button.lvrs__sendcomment', src).off('click').on('click', function() {
		lpcms.show_modal('signup');
	});
	$('.lvrs__postinteractives-likebtn', src).off('click').on('click', function() {
		lpcms.show_modal('signup');
	});
};
window.onerror = function (msg, url, lineNo, columnNo, error) {
	axios.post('/jserr', {
		msg: msg,
		url: url,
		lineNo: lineNo,
		columnNo: columnNo,
		error: error,
		location: window.location.pathname+(window.location.search ? window.location.search : '')
	});
	return false;
};
var vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', vh+'px');
lpcms.oldWindowWidth = window.innerWidth;
lpcms.oldWindowHeight = window.innerHeight;
window.addEventListener('resize', function() {
	var vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', vh+'px');
	if (lpcms.oldWindowWidth != window.innerWidth || lpcms.oldWindowHeight != window.innerHeight) {
		if (typeof lpcms.premium != "undefined" && typeof lpcms.premium.fixVideoLayout != "undefined") {
			lpcms.premium.fixVideoLayout();
		}
	}
	lpcms.oldWindowWidth = window.innerWidth;
	lpcms.oldWindowHeight = window.innerHeight;
});
function extend_jquery() {
	(function($) {
		jQuery.fn.autogrow = $.fn.autogrow = function(subtract, maxheight) {
			$(this).off('input').on('input', function() {
				if (typeof subtract == "undefined") {
					subtract = 0;
				}
				var field = this;
				var oldheight = field.style.height;
				field.style.height = 'inherit';
				var height = field.scrollHeight;
				if (typeof maxheight == "undefined" || height < maxheight) {
					field.style.height = (height - subtract) + 'px';
				} else {
					field.style.height = oldheight;
				}
				$(field).scrollTop(height);
			});
		};
		jQuery.fn.premiumImageSlider = $.fn.premiumImageSlider = function() {
			$(this).each(function() {
				if ($(this).find('li').length >= 2) {
					if (typeof lpcms.premium.imagesliders[$(this).find('li:first').data('postid')] != "undefined") {
						lpcms.premium.imagesliders[$(this).find('li:first').data('postid')].destroy();
					}
					$(this).parent().css('max-width', ($(window).width() <= 425 ? $(window).width() : $('.lvrs__stream').width())+'px');
					lpcms.premium.imagesliders[$(this).find('li:first').data('postid')] = $(this).addClass('lightSlider-active').lightSlider({
						loop: false,
						pager: false,
						pager: true,
						slideMargin: 0,
						enableDrag: false,
						enableTouch: true,
						freeMove: false,
						item: 1,
						autoWidth: false,
						onAfterSlide: () => {
							var slider = $(this).parents('.lpcms-slider');
							if (slider.find('.active .vjs-has-started').length > 0) {
								slider.find('.lSPager').css('visibility','hidden');
							} else {
								slider.find('.lSPager').css('visibility','visible');
							}
						}
					});
				}
			});
		};
	})(jQuery);
};

lpcms.indexedDBRead = function(key) {
	return new Promise((resolve,reject) => {
		var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

		if (indexedDB) {
			var open = indexedDB.open("lpcms", 1);

			open.onupgradeneeded = function() {
				var db = open.result;
				db.createObjectStore("main", {keyPath: "key"});
			};

			open.onsuccess = function() {
				var db = open.result;
				var tx = db.transaction("main", "readwrite");
				var store = tx.objectStore("main");

				var objData = store.get(key);

				objData.onsuccess = function() {
					resolve(objData.result.value);
				};

				tx.oncomplete = function() {
					db.close();
				};
			}
		} else {
			reject();
		}
	});
};
lpcms.indexedDBWrite = function(key, value) {
	return new Promise((resolve,reject) => {
		var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

		if (indexedDB) {
			var open = indexedDB.open("lpcms", 1);

			open.onupgradeneeded = function() {
				var db = open.result;
				db.createObjectStore("main", {keyPath: "key"});
			};

			open.onsuccess = function() {
				var db = open.result;
				var tx = db.transaction("main", "readwrite");
				var store = tx.objectStore("main");
				resolve(store.put({key, value}));
				tx.oncomplete = function() {
					db.close();
				};
			}
		} else {
			reject();
		}
	});
};
lpcms.getIphoneModel = () => {
	var canvas = document.createElement("canvas");
	if (canvas) {
		var context = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
		if (context) {
			var info = context.getExtension("WEBGL_debug_renderer_info");
			if (info) {
				var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL);
			}
		}
	}

	// iPhone X
	if ((window.screen.height / window.screen.width == 812 / 375) && (window.devicePixelRatio == 3)) {
		return "X";
	} else if ((window.screen.height / window.screen.width == 896 / 414) && (window.devicePixelRatio == 3)) {
		return "Xmax-Xr";
	// iPhone 6+/6s+/7+ and 8+
	} else if ((window.screen.height / window.screen.width == 736 / 414) && (window.devicePixelRatio == 3)) {
		switch (renderer) {
			default:
				return "6 Plus, 6s Plus, 7 Plus or 8 Plus";
			case "Apple A8 GPU":
				return "6 Plus";
			case "Apple A9 GPU":
				return "6s Plus";
			case "Apple A10 GPU":
				return "7 Plus";
			case "Apple A11 GPU":
				return "8 Plus";
		}
	// iPhone 6+/6s+/7+ and 8+ in zoom mode
	} else if ((window.screen.height / window.screen.width == 667 / 375) && (window.devicePixelRatio == 3)) {
		switch(renderer) {
			default:
				return "6 Plus, 6s Plus, 7 Plus or 8 Plus";
			case "Apple A8 GPU":
				return "6 Plus";
			case "Apple A9 GPU":
				return "6s Plus";
			case "Apple A10 GPU":
				return "7 Plus";
			case "Apple A11 GPU":
				return "8 Plus";
		}
	// iPhone 6/6s/7 and 8
	} else if ((window.screen.height / window.screen.width == 667 / 375) && (window.devicePixelRatio == 2)) {
		switch(renderer) {
			default:
				return "6, 6s, 7 or 8";
			case "Apple A8 GPU":
				return "6";
			case "Apple A9 GPU":
				return "6s";
			case "Apple A10 GPU":
				return "7";
			case "Apple A11 GPU":
				return "8";
		}
	// iPhone 5/5C/5s/SE or 6/6s/7 and 8 in zoom mode
	} else if ((window.screen.height / window.screen.width == 1.775) && (window.devicePixelRatio == 2)) {
		switch(renderer) {
			default:
				return "5, 5C, 5S, SE or 6, 6s, 7 and 8";
			case "PowerVR SGX 543":
				return "5 or 5c";
			case "Apple A7 GPU":
				return "5s";
			case "Apple A8 GPU":
				return "6";
			case "Apple A9 GPU":
				return "SE or 6s";
			case "Apple A10 GPU":
				return "7";
			case "Apple A11 GPU":
				return "8";
		}
	// iPhone 4/4s
	} else if ((window.screen.height / window.screen.width == 1.5) && (window.devicePixelRatio == 2)) {
		switch(renderer) {
			default:
				return "4 or 4s";
			case "PowerVR SGX 535":
				return "4";
			case "PowerVR SGX 543":
				return "4s";
		}
	// iPhone 1/3G/3GS
	} else if ((window.screen.height / window.screen.width == 1.5) && (window.devicePixelRatio == 1)) {
		switch(renderer) {
			default:
				return "1, 3G or 3GS";
			case "ALP0298C05":
				return "3GS";
			case "S5L8900":
				return "1, 3G";
		}
	}
};

extend_jquery();
function cachebustv2() { return "foo"; }